import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';
import { VerificationRequestCreateByGovernmentVerifierModalForm } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

export const VerificationRequestCreateByGovernmentVerifierModal: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { closeModal, isOpen } = useModal(ModalId.VerificationRequestCreateByGovernmentVerifier);

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => handleCloseModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [handleCloseModal]);

  return (
    <Modal
      title={isMobile ? 'New Request' : 'Create New Verification Request'}
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
        fullScreen: isMobile,
      }}
    >
      <VerificationRequestCreateByGovernmentVerifierModalForm closeModal={handleCloseModal} />
    </Modal>
  );
};
